import type { KpiResultType, KpiResultValueType } from '@carrefour-gcs/shared';

/**
 * Compute the CSS classes to apply based on the given indicator value. Depending on the value
 * the function will return a different set of classes.
 *
 * @param indicatorValue The indicator value to compute the classes for.
 * @returns The classes to apply to the indicator value.
 * @example getComparisonClass({ value: 123 }) // => 'text-success fill-success'
 */
export function getComparisonClass(indicator?: KpiResultValueType | KpiResultType) {
  const value = typeof indicator === 'number' ? indicator : (indicator as KpiResultType).value;

  // --- Return the default classes if the value is not a valid number.
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return 'text-default-disabled fill-default-disabled';
  }

  // --- Return the success classes if the value is positive.
  if (value > 0) {
    return 'text-success fill-success';
  }

  // --- Otherwise return the error classes.
  return 'text-error fill-error';
}
